import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    axios: [],
    modelDefault: {
        id: null,
        bot_id: null
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
